import { useContext } from 'react'
import { AuthContext } from '../../../../Auth/AuthContext'
import ContentHeader from '../../../Layout/ContentHeader'
import { objNameRoles } from '../../../../const/constRoles'
import DashboardGestorGlobal from './components/DashboardGestorGlobal'
import DashboardGestorInterno from './components/DashboardGestorInterno'
import DashboardGestorGlobalIndependiente from './components/DashboardGestorGlobalIndependiente'
import DashboardAtencionCiudadana from './components/DashboardAtencionCiudadana'
import DashboardAdminMaster from './components/DashboardAdminMaster'
import DashboardAdminMasterMayor from './components/DashboardAdminMasterMayor'
import DashboardGestorTramite from '../../../Processes/Components/DashboardGestorTramite'
import DashboardActivityWaterTruckRequest from '../../Catalogs/WaterTruckRequest/components/Dashboard/DashboardActivityWaterTruckRequest'

const ReportsCounters = () => {
  //STATES
  const { user } = useContext(AuthContext)

  const processRoles = [
    objNameRoles.gestor_tramites,
    objNameRoles.revisor_tramites,
    objNameRoles.notificador_tramites,
    objNameRoles.seguimiento_tramites,
  ]

  const pipesRoles = [objNameRoles.gestor_pipas, objNameRoles.provedor_pipas]

  return (
    <>
      <ContentHeader
        title=""
        titleContent={
          <h1 className="header-title">
            Bienvenido{user.name ? `, ${user.name}` : ''}
          </h1>
        }
        breadcrumb=""
        windowTitle="Dashboard"
      />
      {user.role === objNameRoles.gestor_global && <DashboardGestorGlobal />}
      {user.role === objNameRoles.gestor_interno && <DashboardGestorInterno />}
      {user.role === objNameRoles.gestor_global_independiente && (
        <DashboardGestorGlobalIndependiente />
      )}
      {/* {user.role === objNameRoles.admin || user.role === objNameRoles.master && (
        <DashboardAdminMaster />
      )} */}
      {(user.role === objNameRoles.admin ||
        user.role === objNameRoles.master ||
        user.role === objNameRoles.alcalde_tlajomulco) && (
        <DashboardAdminMasterMayor />
      )}
      {user.role === objNameRoles.atencion_ciudadana && (
        <DashboardAtencionCiudadana />
      )}
      {
        // PROCESSESS USERS
        processRoles.includes(user.role) && <DashboardGestorTramite />
      }
      {
        // PIPAS USERS

        pipesRoles.includes(user.role) && <DashboardActivityWaterTruckRequest />
      }
    </>
  )
}

export default ReportsCounters
